// extracted by mini-css-extract-plugin
module.exports = {"pending":"AdminInputsIcon_pending__21CH9","complete":"AdminInputsIcon_complete__22thW"};